
export const convertContentToLinkTarget = (target: Link['link_target']): '_blank' | '_self' => target === 'New Tab' ? '_blank' : '_self';